var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 80,
    viewBox: "0 0 22 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_10845_37645",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 0L18.457 59.5215H3.22266L0 0H21.6797ZM20.0684 63.2324V79.0527H1.61133V63.2324H20.0684Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 0L22.6782 0.0540619L22.7353 -1H21.6797V0ZM18.457 59.5215V60.5215H19.4044L19.4556 59.5755L18.457 59.5215ZM3.22266 59.5215L2.22412 59.5755L2.27533 60.5215H3.22266V59.5215ZM0 0V-1H-1.05561L-0.998538 0.0540619L0 0ZM20.0684 63.2324H21.0684V62.2324H20.0684V63.2324ZM20.0684 79.0527V80.0527H21.0684V79.0527H20.0684ZM1.61133 79.0527H0.611328V80.0527H1.61133V79.0527ZM1.61133 63.2324V62.2324H0.611328V63.2324H1.61133ZM21.6797 0L20.6812 -0.0540619L17.4585 59.4674L18.457 59.5215L19.4556 59.5755L22.6782 0.0540619L21.6797 0ZM18.457 59.5215V58.5215H3.22266V59.5215V60.5215H18.457V59.5215ZM3.22266 59.5215L4.22119 59.4674L0.998538 -0.0540619L0 0L-0.998538 0.0540619L2.22412 59.5755L3.22266 59.5215ZM0 0V1H21.6797V0V-1H0V0ZM20.0684 63.2324H19.0684V79.0527H20.0684H21.0684V63.2324H20.0684ZM20.0684 79.0527V78.0527H1.61133V79.0527V80.0527H20.0684V79.0527ZM1.61133 79.0527H2.61133V63.2324H1.61133H0.611328V79.0527H1.61133ZM1.61133 63.2324V64.2324H20.0684V63.2324V62.2324H1.61133V63.2324Z",
    fill: "#C691FB",
    mask: "url(#path-1-inside-1_10845_37645)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation_mark.3585e1b5249fe03be43003ae136ea9e6.svg";
export { ForwardRef as ReactComponent };